<template>
  <section class="card manager"><span class="eyebrow">ВАШ МЕНЕДЖЕР</span><h3>{{ name }}</h3><p class="prewrap">{{ manager && manager.phones || 'Контактные данные можно уточнить у вашей команды сопровождения.' }}</p><span class="muted">По вопросам услуг, документов и доступа в кабинет.</span></section>
</template>
<script>
export default {
  computed: {
    manager() { return this.$store.state.manager },
    name() { return this.manager ? [this.manager.family, this.manager.name, this.manager.otch].filter(Boolean).join(' ') : 'Всегда на связи' }
  }
}
</script>
